// import { createSelector } from 'reselect'
import { getCurrentFromPrograms } from '../libs/channels'
import {
  VIEW_MODE_CHANNEL_BANNER,
  VIEW_MODE_CHANNEL_GUIDE,
  VIEW_MODE_CHANNEL_LIST,
  VIEW_MODE_FAVORITE_LIST
} from '../constants/channels'

export const shouldFetch = state => !state.channels.isReady && !state.channels.isFetching
export const isReady = state => state.channels.isReady
export const isRadioListReady = state => state.channels.isRadioListReady
export const hasError = state => state.channels.error
export const getErrorMessage = state => state.channels.errorMessage
export const isSidebarOpen = state => (
     state.channels.viewMode === VIEW_MODE_CHANNEL_LIST
  || state.channels.viewMode === VIEW_MODE_FAVORITE_LIST
)
export const isChannelGuideOpen = state => state.channels.viewMode === VIEW_MODE_CHANNEL_GUIDE
export const isChannelBannerOpen = state => state.channels.viewMode === VIEW_MODE_CHANNEL_BANNER
export const didInvalidate = state => state.channels.didInvalidate

export const getViewMode = state => state.channels.viewMode
export const getChannelsById = state => state.channels.byId
export const getAllChannelIds = state => state.channels.allIds
export const getSelectedId = state => state.channels.selectedId
export const getFocusedId = state => state.channels.focusedId
export const getFocusedProgram = state => state.channels.focusedProgram
export const getSelectedChannelBanner = state => state.channels.selectedChannelBanner
export const getChannelGuideInterval = state => state.channels.channelGuideInterval

export const getChannelById = (state, id) => state.channels.byId[id]
export const getAllPrograms = state => state.channels.programs
export const getPrograms = (state, id) => (state.channels.programs[id] ? state.channels.programs[id] : [])
export const getProgramsIsFetching = state => state.channels.programsIsFetching
export const getProgramsTo = state => state.channels.programsTo

export const getChannels = (state) => {
  const allIds = getAllChannelIds(state)
  const byId = getChannelsById(state)
  return allIds.map((id) => byId[id])
}

export const getSelectedChannel = (state) => {
  const selectedId = getSelectedId(state)
  const byId = getChannelsById(state)
  return typeof byId[selectedId] !== 'undefined' ? byId[selectedId] : {}
}

export const getChannelChangerNumber = state => state.channels.channelChangerNumber
export const isChannelChangerOpen = state => state.channels.channelChangerOpen
export const isChannelChangerError = state => state.channels.channelChangerError

export const getCurrentProgram = (state, id) => getCurrentFromPrograms(getPrograms(state, id))

export const hasClosedCaptions = state => state.channels.hasClosedCaptions
export const closedCaptionsShown = state => state.channels.closedCaptionsShown

export const programDvrsLastRetrieved = state => state.channels.programDvrsLastRetrieved
export const getRequestedDvr = state => state.channels.requestedDvr

export const getCategory = state => state.channels.category
export const getCategories = state => Object.keys(state.channels.byCategory)
export const getFilteredChannelIds = state => {
  let channelIds
  if (state.channels.category === '' || state.channels.category === '_all_') {
    channelIds = state.channels.allIds
  } else if (typeof state.channels.byCategory[state.channels.category] !== 'undefined') {
    channelIds = state.channels.byCategory[state.channels.category]
  } else {
    channelIds = []
  }
  return channelIds
}
export const getFilteredChannels = state => {
  const channelIds = getFilteredChannelIds(state)
  const byId = getChannelsById(state)
  return channelIds.map((id) => byId[id])
}

export const getSocialBroadcastersAvailable = (state) => state.channels.socialBroadcastersAvailable
export const getSocialBroadcastersRequested = (state) => state.channels.socialBroadcastersRequested
export const getSocialBroadcasters = (state) => state.channels.socialBroadcastersAvailable && state.channels.socialBroadcastersRequested

export const getChannelPackageById = (state, packageId) => state.channels.packagesById[packageId]
export const getChannelPackages = (state, channelId) => {
  if (typeof state.channels.packages[channelId] !== 'undefined') {
    const packages = []
    state.channels.packages[channelId].packages.forEach(packageId => {
      if (typeof state.channels.packagesById[packageId] !== 'undefined') {
        packages.push(state.channels.packagesById[packageId])
      }
    })
    return packages
  } else {
    return []
  }
}
export const getSelectedChannelPackages = (state) => getChannelPackages(state, getSelectedId(state))

/**
 * featured channels
 */
export const getFeaturedReady = state => state.channels.featuredReady
export const getFeaturedShouldFetch = state => !state.channels.featuredReady && !state.channels.featuredFetching
export const getFeaturedHasError = state => state.channels.featuredHasError
export const getFeaturedErrorMessage = state => state.channels.featuredErrorMessage

export const getFeaturedChannelIds = state => state.channels.featuredIds
export const getFeaturedChannels = state => {
  const featuredIds = getFeaturedChannelIds(state)
  const byId = getChannelsById(state)
  return featuredIds.map(id => byId[id])
}
export const getFeaturedPosition = state => state.channels.featuredPosition
export const getTvChannelsCount = state => {
  let count = 0
  for (const channelId in state.channels.byId) {
    if (state.channels.byId[channelId].type === 'live') {
      count++
    }
  }
  return count
}
